import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { lang: { type: String, default: 'en' } };
  static targets = ['panel', 'tab'];

  connect() {
    this._update();
  }

  selectLang(event) {
    this.langValue = event.currentTarget.dataset.lang;
    this._update();
  }

  _update() {
    var current = this.langValue;

    this.panelTargets.forEach(function(panel) {
      panel.style.display = panel.dataset.lang === current ? '' : 'none';
    });

    this.tabTargets.forEach(function(tab) {
      tab.classList.toggle('active', tab.dataset.lang === current);
    });
  }
}
